import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";

import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { CoreModule, createTranslateLoader } from "./core/core.module";
import { registerLocaleData, CommonModule } from "@angular/common";
import localeEs from "@angular/common/locales/es";

import { SharedModule } from "./shared/shared.module";
import { ClientGuard } from "./core/client/client.guard";
import { TranslateModule, TranslateLoader } from "@ngx-translate/core";
import { HttpClient, HttpClientModule } from "@angular/common/http";


registerLocaleData(localeEs, "es");

@NgModule({
  declarations: [AppComponent],
  imports: [
    HttpClientModule,
    BrowserModule,
    AppRoutingModule,
    CommonModule,
    SharedModule,
    BrowserAnimationsModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient],
      },
      isolate: false,
    }),
    CoreModule.forRoot(),
  ],
  providers: [ClientGuard],
  bootstrap: [AppComponent],
})
export class AppModule {}
